import nawatechLogo from "./assets/nawatech-logo.png"

const NotFoundPage = ({ message = "Page not found", code = "404" }) => {
    return (
            <div className="not-found-container">
                <img src={nawatechLogo} style={{ height: "60px" }} />
                <div>{message} | {code}</div>
            </div>
    )
}

export default NotFoundPage